export const ACTIVE_QUEUE_ID = 'active-queue';
export const INACTIVE_QUEUE_ID = 'inactive-queue';
export const SURVEY_INTERVAL_WEEKS = 4;
